import { useState, type ReactNode } from 'react'
import { createPageNavigationState } from '@/lib/navigation/page-state'
import { PageNavigationContext } from './page-context'

export function PageNavigationProvider({ children }: { children: ReactNode }) {
  const [navigation] = useState(createPageNavigationState)
  return <PageNavigationContext.Provider value={navigation}>{children}</PageNavigationContext.Provider>
}
